import _slicedToArray from 'babel-runtime/helpers/slicedToArray';
import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

import ModalFormHeader from '../Form/ModalFormHeader';
import ModalForm from '../Form/ModalForm';
import ErrorMessage from '../Form/ErrorMessage';
import FinePrintMessage from '../Form/FinePrintMessage';
import SuccessMessage from '../Form/SuccessMessage';

import { getCookie, setCookie } from '../../Utils/FormUtils';
import { StyledWrapper, StyledContainer, StyledFormWrapper } from './DataCaptureFormStyles';

var _ref = React.createElement(FinePrintMessage, null);

var DataCaptureForm = function DataCaptureForm(props) {
  var formRef = useRef(null);
  var successRef = useRef(null);
  var errorRef = useRef(null);
  var redirectLocation = window.Dormify.data_capture_redirect_location && window.Dormify.data_capture_redirect_location !== '' ? '/pages/' + window.Dormify.data_capture_redirect_location : '/';
  var bgImage = window.Dormify.data_capture_bg_image;
  var bgImageMobile = window.Dormify.data_capture_bg_mobile;
  var bgPosX = window.Dormify.data_capture_bg_pos_x;
  var bgPosY = window.Dormify.data_capture_bg_pos_y;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isSmsSubmission = _useState2[0],
      setIsSmsSubmission = _useState2[1];

  useEffect(function () {
    var viewCookie = getCookie('dormify_modal_form_viewed');
    var submittedCookie = getCookie('dormify_modal_form_submitted');
    // Add viewed modal cookie to ensure modal doesn't appear after viewing this page (??)
    if (!viewCookie && !submittedCookie) {
      setCookie('dormify_modal_form_viewed', true, 90);
    }
  }, []);

  return React.createElement(
    StyledWrapper,
    {
      bgImage: bgImage,
      bgImageMobile: bgImageMobile,
      bgPosX: bgPosX,
      bgPosY: bgPosY,
      isModal: props.isModal
    },
    React.createElement(
      StyledContainer,
      { isModal: props.isModal },
      React.createElement(
        StyledFormWrapper,
        {
          className: 'data-capture-modal__form-wrapper',
          ref: formRef,
          tabIndex: '-1',
          isModal: props.isModal
        },
        React.createElement(ModalFormHeader, { discountOff: props.formDiscount.discountOff }),
        React.createElement(ErrorMessage, { ref: errorRef, align: 'center' }),
        React.createElement(ModalForm, {
          formRef: formRef,
          successRef: successRef,
          errorRef: errorRef,
          handleFormSubmitDiscountCode: props.handleFormSubmitDiscountCode,
          isModal: props.isModal,
          setIsSmsSubmission: setIsSmsSubmission,
          redirectLocation: redirectLocation
        }),
        _ref
      ),
      React.createElement(SuccessMessage, {
        ref: successRef,
        formDiscount: props.formDiscount,
        isSmsSubmission: isSmsSubmission
      })
    )
  );
};

DataCaptureForm.propTypes = {
  handleFormSubmitDiscountCode: PropTypes.func,
  formDiscount: PropTypes.object,
  isModal: PropTypes.bool
};

export default DataCaptureForm;